// extracted by mini-css-extract-plugin
export default {"subSection":"Subscribe_subSection__+E91t","inputContainer":"Subscribe_inputContainer__tQFdR"};